/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cargo_Total_Bags_RequiredInputs */

const en_cargo_total_bags_required = /** @type {(inputs: Cargo_Total_Bags_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total bags must be greater than 0`)
};

const es_cargo_total_bags_required = /** @type {(inputs: Cargo_Total_Bags_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Las bolsas totales deben ser mayor a 0`)
};

/**
* | output |
* | --- |
* | "Total bags must be greater than 0" |
*
* @param {Cargo_Total_Bags_RequiredInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const cargo_total_bags_required = /** @type {((inputs?: Cargo_Total_Bags_RequiredInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cargo_Total_Bags_RequiredInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cargo_total_bags_required(inputs)
	return es_cargo_total_bags_required(inputs)
});